export default __webpack_public_path__ + "static/media/help-rav-qa-8.b2691b5e.png";